import { Component, Input, Inject } from '@angular/core';
import { ModalsHandlerServiceNg2 } from '../../../common/modal/ng2/SimplaexModalsHandlerServiceNg2';
import './exploreWidgetWrapperNg2.html';

@Component({
    selector: 'explore-widget-wrapper-ng2',
    template: require('./exploreWidgetWrapperNg2.html')
})


export class ExploreWidgetWrapperComponentNg2 {
    @Input() title: string;
    @Input() subtitle: string;
    @Input() showBenchmarkComparison: boolean = true;
    @Input() isNoGroupLoadedAndPristineFilters: boolean;
    @Input() benchmarkValue: number;
    @Input() value: number;
    @Input() icon: string = "";
    differenceInPercentage: number;
    @Input() wrapperClasses: string = "";
    @Input() breakdownConfig = undefined;
    showBreakdown: boolean = false;

    constructor(@Inject(ModalsHandlerServiceNg2) private modalsHandlerServiceNg2: ModalsHandlerServiceNg2) {}

    onIsOpenChange($event) {
        this.showBreakdown = $event;
    }

    getPercentageColor() {
        return this.differenceInPercentage == 0 ?  '#a2a2a2' : this.differenceInPercentage > 0 ? '#4fcfa1' : '#fd7b87';
    }

    ngOnChanges() {
        this.differenceInPercentage = (this.value - this.benchmarkValue) / this.benchmarkValue * 100;
    }

    getModalId() {
        return `explore-breakdown-modal-${this.breakdownConfig.metric}`
    }

    closeModal() {
        this.modalsHandlerServiceNg2.close(this.getModalId());
    }

    openModal() {
        this.modalsHandlerServiceNg2.open(this.getModalId());
    }
}


/** WEBPACK FOOTER **
 ** ./src/components/explore/widgets/exploreWidgetWrapperNg2.ts
 **/